export const CREATE_DASHBOARD_NAME = "create_dashboard";
export const CREATE_DASHBOARD_DESC = `Creates a dashboard (Analytics workspace home board) via GraphQL mutation.

Use when the user asks to make a new dashboard inside a workspace/organization.
If the user has not specified which workspace to use, ask them for the organizationId (workspace ID) first.

Input:
- 'organizationId' (required): Target workspace/organization ID where the dashboard will live.
- 'name' (required): Dashboard display name.

Notes:
- Performs a write operation (mutation) and returns the created dashboard's id plus link helpers.
- Also returns 'dashboardPath' (relative) and 'dashboardUrl' (absolute when available) so the user can open it immediately.`;
